var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoSmokingSignOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 13C17.4477 13 17 13.4477 17 14C17 14.5523 17.4477 15 18 15H19.5C20.0523 15 20.5 14.5523 20.5 14C20.5 13.4477 20.0523 13 19.5 13H18Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 14C2 7.37258 7.37258 2 14 2C20.6274 2 26 7.37258 26 14C26 20.6274 20.6274 26 14 26C7.37258 26 2 20.6274 2 14ZM5.92858 8.09527C4.71602 9.74997 4 11.7914 4 14C4 19.5228 8.47715 24 14 24C16.2086 24 18.25 23.284 19.9047 22.0714L12.8333 15H8.5C7.94772 15 7.5 14.5523 7.5 14C7.5 13.4477 7.94772 13 8.5 13H10.8333L5.92858 8.09527ZM7.2675 6.60576L21.3942 20.7325C23.013 18.9556 24 16.5931 24 14C24 8.47715 19.5228 4 14 4C11.4069 4 9.04437 4.98698 7.2675 6.60576Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSmokingSignOutline);
export default __webpack_public_path__ + "static/media/no_smoking_sign_outline.9c139775e00ab73afd90c5c6be5aef7c.svg";
export { ForwardRef as ReactComponent };